module.exports = __webpack_public_path__ + "img/18ebd87.svg";